// extracted by mini-css-extract-plugin
export default {"no-city-block":"NoCityBlock_no-city-block__faF+x"};